import { Dropdown, Button } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import FileIcon from "../../../../components/icons/FileIcon";
import PermissionModal from "../Modal/PermissionModal";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../constant/routes";

const FileCard = ({ file, user_id, setSelectedRecord }) => {
  const navigate = useNavigate();
  return (
    <div
      className="file-item cursor-pointer relative"
      onClick={() => navigate(`${ROUTES.EXCEL}/${file?.id}`)}
    >
      {user_id === file?.created_by_user_id && (
        <Dropdown
          menu={{
            items: [
              {
                key: "permission",
                label: <PermissionModal file={file} />,
                onClick: ({ domEvent }) => domEvent.stopPropagation(),
              },
              {
                key: "rename",
                label: "Rename",
                onClick: ({ domEvent }) => {
                  domEvent.stopPropagation();
                  setSelectedRecord({ ...file, isFile: true });
                },
              },
              {
                key: "delete",
                label: "Delete",
                onClick: ({ domEvent }) => {
                  domEvent.stopPropagation();
                  setSelectedRecord({ ...file, isFile: true, isDelete: true });
                },
              },
            ],
          }}
          trigger={["hover"]}
        >
          <Button className="more-option" type="text" icon={<MoreOutlined />} />
        </Dropdown>
      )}

      <FileIcon />
      <div className="ellipsis-text name">{file.name}</div>
    </div>
  );
};

export default FileCard;
